export const addJobView = (url, internalSource, externalSource) => {
    return $.post(url, {
        source: internalSource,
        ext: externalSource,
    });
};
